import { render, staticRenderFns } from "./xivgear_sheet_set_selection.vue?vue&type=template&id=1a5a0725"
import script from "./xivgear_sheet_set_selection.vue?vue&type=script&lang=ts"
export * from "./xivgear_sheet_set_selection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports